module.exports = __webpack_public_path__ + "img/dark-personal-portfolio-landing.1f089fff.png";